export default __webpack_public_path__ + "static/media/icon_width.32a85f35.png";